import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-bulb",
  templateUrl: "./med-icon-bulb.component.html",
})
export class MedIconBulbComponent extends SvgMixinComponent {}
